/* INDEX FILE
It exports as default the reducer function of the duck.
It exports as named export the selectors and the operations.
Optionally it exports the actions and types if they are needed in other ducks.
*/

import reducers from "./reducers";

import resolutionCenterService from "./service";
import resolutionCenterTypes from "./types";
import resolutionCenterActions from "./actions";

export {
  resolutionCenterService,
  resolutionCenterActions,
  resolutionCenterTypes,
};

export default reducers;
